import axios from "axios";
import { staffClient } from "common/apis/staff";
import BasePageLayout from "components/Layout/BasePage";
import PagingTable, { EMPTY_PAGING_TABLE_RET, PagingTableData } from "components/Table/Paging";
import PageTitle from "components/Title/Page";
import React, { useEffect, useState } from "react";
import { columns } from "./config";
import { toast } from "react-toastify";
import { randomStr } from "components/Utils/ui";
import _ from "lodash";

const PartnerList = () => {
    const [refreshKey, setRefreshKey] = useState("");

    useEffect(() => {
        console.log("PartnerList");
    }, [])

    const fetchData = async (page, limit): Promise<PagingTableData> => {
        try {
            const params = {
                offset: (page - 1) * limit,
                limit
            }
            const ret = await staffClient.get(`/partner`, { params });
            console.log("[fetchData] ret", ret);
            return {
                data: ret?.data?.data,
                total: ret?.data?.meta?.total,
                page
            }
        } catch (e) {
            console.log("[fetchData] error", e);
            return EMPTY_PAGING_TABLE_RET;
        }
    }

    const handleCreate = async (row) => {
        try {
            const ret = await staffClient.post(`/partner`, row);
            console.log("[handleCreate] ret", ret);
            setRefreshKey(randomStr());
            toast.success("파트너가 생성되었습니다.");
            return true;
        } catch (e) {
            console.error("[handleCreate] error", e);
            toast.error("파트너 생성에 실패했습니다.");
            return false;
        }
    }

    const handleEdit = async (row) => {
        try {
            const body = _.omit(row, ["id", "clinic"]);
            const ret = await staffClient.patch(`/partner/${row.id}`, body);
            console.log("[handleEdit] ret", ret);
            setRefreshKey(randomStr());
            toast.success("파트너가 수정되었습니다.");
            return true;
        } catch (e) {
            console.error("[handleEdit] error", e);
            toast.error("파트너 수정에 실패했습니다.");
            return false;
        }
    }

    const handleDelete = async (row) => {
        try {
            const ret = await staffClient.delete(`/partner/${row.id}`);
            console.log("[handleDelete] ret", ret);
            setRefreshKey(randomStr());
            toast.success("파트너가 삭제되었습니다.");
            return true;
        } catch (e) {
            console.error("[handleDelete] error", e);
            toast.error("파트너 삭제에 실패했습니다.");
            return false;
        }
    }

    return (
        <BasePageLayout>
            <PageTitle>파트너 목록</PageTitle>
            <PagingTable
                fetchData={fetchData}
                columns={columns}
                isCrudable={true}
                onCreate={handleCreate}
                onEdit={handleEdit}
                onDelete={handleDelete}
                refreshKey={refreshKey}
            />
        </BasePageLayout>
    )
}

export default PartnerList;